module.exports = __webpack_public_path__ + "static/media/8OLA23.c25a4900.jpg";